import type {TrimFeatureAssignmentInput} from '@dms/api/new-vehicle';

type Inclusion = TrimFeatureAssignmentInput['inclusion'];

/** A trim's full assignment set with `featureId` set to `inclusion`, appended when it is new. */
export const setTrimInclusion = (
  assignments: TrimFeatureAssignmentInput[],
  featureId: string,
  inclusion: Inclusion
): TrimFeatureAssignmentInput[] =>
  assignments.some((assignment) => assignment.featureId === featureId)
    ? assignments.map((assignment) =>
        assignment.featureId === featureId ? {...assignment, inclusion} : assignment
      )
    : [
        ...assignments,
        {
          featureId,
          inclusion,
          appliesIf: {anyOfVariantIds: [], allOfFeatureIds: []},
          priceIf: [],
          variantPriceOverrides: [],
          priceDeltaNet: null,
          sortOrder: assignments.length,
        },
      ];
